var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboNoStock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83301 1.33333C10.9597 1.33333 13.4997 3.87333 13.4997 7C13.4997 10.1267 10.9597 12.6667 7.83301 12.6667C4.70634 12.6667 2.16634 10.1267 2.16634 7C2.16634 3.87333 4.70634 1.33333 7.83301 1.33333ZM7.83301 0C3.96634 0 0.833008 3.13333 0.833008 7C0.833008 10.8667 3.96634 14 7.83301 14C11.6997 14 14.833 10.8667 14.833 7C14.833 3.13333 11.6997 0 7.83301 0Z",
    fill: "#DF0C0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9067 4H9.96669C9.88002 4 9.79335 4.03333 9.73335 4.1L7.77335 6.06L5.81335 4.1C5.75335 4.04 5.66669 4 5.58002 4H4.64002C4.34002 4 4.19335 4.36 4.40669 4.56667L6.84002 7L4.40669 9.43333C4.20002 9.64 4.34669 10 4.64002 10H5.58002C5.66669 10 5.75335 9.96667 5.81335 9.9L7.77335 7.94L9.73335 9.9C9.79335 9.96 9.88002 10 9.96669 10H10.9067C11.2067 10 11.3534 9.64 11.14 9.43333L8.70669 7L11.14 4.56667C11.3467 4.36 11.2 4 10.9067 4Z",
    fill: "#DF0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboNoStock);
export default __webpack_public_path__ + "static/media/FBONoStock.b3e5163b175cf1efc0ca53532ee6fe92.svg";
export { ForwardRef as ReactComponent };